import { render, staticRenderFns } from "./DeletedUsersOverview.vue?vue&type=template&id=37871d2a&scoped=true&"
import script from "./DeletedUsersOverview.vue?vue&type=script&lang=js&"
export * from "./DeletedUsersOverview.vue?vue&type=script&lang=js&"
import style0 from "./DeletedUsersOverview.vue?vue&type=style&index=0&id=37871d2a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37871d2a",
  null
  
)

export default component.exports